import { atom } from "recoil";

export const productManagementAtom = atom({
    key: 'productManagementAtom',
    default: {
        isClose: false,
        componentType: ''
    }
});